import { ReactElement } from 'react';
import { Typography } from '@weareopenr/component-library';
import { ScheduleSelector } from 'src/components/PublishDetailsView/PublishDetailsView';
import ChannelsField from 'src/components/PublishModal/ChannelsField/ChannelsField';
import { oneInstancePerExternalSystem } from 'src/hooks/useTimetablePublishDestinations/oneInstancePerExternalSystem';
import { ITimetableSetupViewProps } from '../types';
import styles from '../../PublishModal/PublishSetupView/PublishSetupView.module.scss';
import localStyles from './TimetableSetupView.module.scss';

const TimetableSetupView = ({
  control,
  register,
  watch,
  timetableName,
  publicationData,
}: ITimetableSetupViewProps): ReactElement => {
  return (
    <section className={styles['setup']}>
      <div className={localStyles['heading-group']}>
        <Typography weight="bold" size="medium" className={localStyles['eyebrow']}>
          Timetable Publish
        </Typography>
        <Typography size="xxlarge" className={styles['heading']}>
          Publish <strong>{timetableName}</strong>
        </Typography>
      </div>

      <ChannelsField
        control={control}
        publicationData={publicationData}
        getDisabledReason={(destination, selectedIds) =>
          oneInstancePerExternalSystem(publicationData, destination, selectedIds)
        }
      />

      <div className={styles['section']}>
        <ScheduleSelector
          register={register}
          watch={watch}
          title="Publish time & date"
          titleSize="medium"
          titleWeight="bold"
          dateLabel="Start Date & Time"
          nowLabel="Publish now"
          scheduleLabel="Schedule"
          showScheduleName
          showConfirmationCheckbox
          radioContainerClassName={styles['schedule-radios']}
          titleClassName={styles['schedule-title']}
        />
      </div>
    </section>
  );
};

export default TimetableSetupView;
